import React, { useContext, useEffect, useState } from 'react';
import styles from './Cards.module.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperCustom from 'components/SwiperCustom/SwiperCustom';
import { addCustomPathToLink, generateKey } from '../../functions';
import { SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import { DataContext } from '../../views/pages/Root';

const Cards = ({ api }) => {
  const data = useContext(DataContext);
  const [subcategories, setSubcategories] = useState(null);

  useEffect((_) => {
    if (!!data?.pages?.length && !!api.attributes?.subcategories?.length) setSubcategories(data.pages);
  }, []);

  return (
    <section
      id={api?.id}
      className={`wrapper ${styles.cardWrapper}`}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      {!!api.attributes.title && (
        <h2
          data-aos="fade-up"
          className={`${styles.tittle} ${!!api.attributes.description ? '' : styles.negativeMarginBottom}`}
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          {api.attributes.title}
        </h2>
      )}
      {!!api.attributes.description && (
        <p
          data-aos="fade-up"
          className={`${styles.description} ${styles.negativeMarginBottom}`}
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          {api.attributes.description}
        </p>
      )}

      <SwiperCustom animationData={{ animation: 'fade-up', animationDuration: '1000', animationEasing: 'easy-in-out' }} spaceBetween={5}>
        {!!subcategories &&
          !!api.attributes?.subcategories?.length &&
          api.attributes.subcategories?.map((id) => {
            const currentPage = subcategories.find((page) => page?.id == id);
            return (
              !!currentPage && (
                <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
                  <Link to={addCustomPathToLink(`/${currentPage.slug}`)}>
                    {!!currentPage?.cover && (
                      <figure>
                        <img
                          className={styles.cardImage}
                          src={addCustomPathToLink(currentPage.cover, true)}
                          alt={!!currentPage?.image?.alt ? currentPage.image.alt : 'image'}
                        />
                      </figure>
                    )}
                    {!!currentPage?.name && (
                      <button type="button" className={styles.productTitle}>
                        {currentPage?.name}
                      </button>
                    )}
                  </Link>
                </SwiperSlide>
              )
            );
          })}
        {!!api.attributes?.data?.length &&
          api.attributes.data?.map((currentPage) => {
            return (
              !!currentPage && (
                <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
                  <a href={currentPage.linkBtn} target="_blank">
                    {!!currentPage?.image && (
                      <figure>
                        <img
                          className={styles.cardImage}
                          src={addCustomPathToLink(currentPage.image.src, true)}
                          alt={!!currentPage?.image?.alt ? currentPage.image.alt : 'image'}
                        />
                      </figure>
                    )}
                    {!!currentPage?.linkBtn && (
                      <button type="button" className={styles.productTitle}>
                        {!!currentPage?.textBtn ? currentPage.textBtn : 'Zobacz'}
                      </button>
                    )}
                  </a>
                </SwiperSlide>
              )
            );
          })}
      </SwiperCustom>
    </section>
  );
};

export default Cards;
